import type { HandleProps } from "@xyflow/react";

import { BaseHiddenHandle } from "./styled/basehandle.styled";

/**
 * A hidden handle that is used to connect to a node, used for decision true/false edges.
 */
const AddHiddenHandle = (props: HandleProps) => {
	return <BaseHiddenHandle {...props} />;
};

export default AddHiddenHandle;
